import React from 'react'
import PropTypes from 'prop-types'

const Button = ({ label, onClick, className, disabled, color, backgroundcolor, value, style }) => {
  const classMapping = {
    save: 'savebutton',
    cancel: 'cancelbutton',
    clear: 'clearbutton',
    delete: 'deletebutton',
    add: 'addbutton',
    update: 'savebutton',
  }

  return (
    <button
      style={{
        backgroundColor: backgroundcolor,
        color: color,
        opacity: disabled ? 0.6 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
        ...style,
      }}
      onClick={onClick}
      value={value}
      className={`${className} ${classMapping[label.toLowerCase()] || ''}`}
      disabled={disabled}
    >
      {label}
    </button>
  )
}

Button.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.any,
  color: PropTypes.string,
  value: PropTypes.string,
  backgroundcolor: PropTypes.string,
  style: PropTypes.string,
}

Button.defaultProps = {
  label: '',
  onClick: () => { },
  className: '',
  disabled: false,
  value: ""
}

export default Button
